import { date } from '@/lib/date';

const MONTHS_SHORT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];
const pad = (n: number) => String(n).padStart(2, '0');

export const coupleName = (c: { husbandName: string; wifeName: string }) =>
  `${c.husbandName.split(' ')[0]} e ${c.wifeName}`;

export const coupleInitials = (c: { husbandName: string; wifeName: string }) =>
  `${c.husbandName[0] ?? ''}${c.wifeName[0] ?? ''}`.toUpperCase();

export const nameInitials = (name: string) =>
  name
    .split(' ')
    .filter(Boolean)
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

export const phoneBR = (v?: string | null) => {
  const d = (v ?? '').replace(/\D/g, '');
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return v ?? '';
};

export const cepBR = (v?: string | null) => {
  const d = (v ?? '').replace(/\D/g, '');
  return d.length === 8 ? `${d.slice(0, 5)}-${d.slice(5)}` : (v ?? '');
};

export const shortDate = (v: string | Date) => {
  const d = date(v);
  return `${pad(d.date())} ${MONTHS_SHORT[d.month()]}`;
};

/** "07 e 08 Nov 2026" ou "30 Out – 01 Nov 2026". */
export const eventRange = (e: { startDate: string | Date; endDate: string | Date }) => {
  const a = date(e.startDate);
  const b = date(e.endDate);
  const head =
    a.month() === b.month()
      ? `${pad(a.date())} e ${shortDate(e.endDate)}`
      : `${shortDate(e.startDate)} – ${shortDate(e.endDate)}`;
  return `${head} ${b.year()}`;
};

/** "07 E 08 DE NOVEMBRO DE 2026" — usado em eyebrows. */
export const eventRangeLong = (e: {
  startDate: string | Date;
  endDate: string | Date;
}) => {
  const a = date(e.startDate);
  const b = date(e.endDate);
  if (a.month() === b.month())
    return `${a.format('DD')} e ${b.format('DD')} de ${b.format('MMMM')} de ${b.year()}`;
  return `${a.format('DD')} de ${a.format('MMMM')} a ${b.format('DD')} de ${b.format('MMMM')} de ${b.year()}`;
};

export const eventShort = (description?: string) =>
  description ? description.replace(/^Retiro\s+/i, '') : '—';

/** "Hoje, 14:32", "Ontem, 09:10" ou "18 Out". */
export const relativeWhen = (v: string | Date) => {
  const d = date(v);
  const diff = date().startOf('day').diff(d.startOf('day'), 'day');
  const hm = d.format('HH:mm');
  if (diff === 0) return `Hoje, ${hm}`;
  if (diff === 1) return `Ontem, ${hm}`;
  return shortDate(v);
};

export const MONTHS_UPPER = MONTHS_SHORT.map((m) => m.toUpperCase());
